import React from 'react';
import Link from 'react-router/lib/Link';
import { t } from '../../../../../modules/infra/i18n';

import * as shapes from '../shapes';
import TaxesTable from './TaxesTable';
import * as commonShapes from '../../../../common/shapes';
import withPermissions from '../../../../auth/utils/withPermissions';
import { canUserModifyTaxes } from '../../../../common/helpers/users';

const List = props => (
  <div className="c-wrapper">
    <div className="u-margin-auto u-mv-">
      <div className="u-text-right u-mb-">
        <Link
          className="c-btn c-btn--medium u-width-120"
          to={`${props.baseUrl}/add`}
          display-if={canUserModifyTaxes(props.permissions)}
        >
          {t('settings:taxes.add_tax_button')}
        </Link>
      </div>
      <TaxesTable {...props} />
    </div>
  </div>
);

List.propTypes = {
  baseUrl: shapes.url,
  permissions: commonShapes.permissions.isRequired,
};

List.defaultProps = {
  taxes: [],
  baseUrl: '/settings/taxes',
};

export default withPermissions(List);
